var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-list"},[_c('TableHeaderContainer',{attrs:{"fields":_vm.dataFields,"styles":_vm.styleObject}}),_c('TableRowContainer',{ref:"users-table",attrs:{"data":_vm.users,"styles":_vm.styleObject,"dataKeys":_vm.dataKeys,"selectedItem":_vm.selectedItem,"pathIdParam":'userId'},on:{"selectedElement":_vm.setSelectedUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }